import styled from "styled-components";

const FinalDataWrapper = styled.div``;

export { FinalDataWrapper };
